// Pure, dependency-free embedded-context check shared by ShopifyEmbeddedService and
// AuthSessionService. Kept out of both classes so AuthSessionService can decide where the
// Xoopah token lives without creating a circular dependency with ShopifyEmbeddedService.
export function isShopifyEmbeddedContext(): boolean {
  const params = new URLSearchParams(window.location.search);
  const bridge = (globalThis as typeof globalThis & { shopify?: { config?: { shop?: string }; shop?: string } }).shopify;
  return window.self !== window.top && (!!params.get('host') || !!bridge);
}
